import { useQuery } from "@tanstack/react-query";
import { Reveal } from "@/components/Reveal";
import api from "@/lib/api";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export function FaqSection() {
  const { data: faqs = [] } = useQuery({ queryKey: ["faqs"], queryFn: () => api.get("/faqs").then((r) => r.data) });

  return (
    <section id="faq" className="border-t border-border py-24 md:py-36" data-testid="faq-section">
      <div className="container-px mx-auto max-w-[1600px]">
        <div className="grid gap-16 lg:grid-cols-[0.8fr_1.4fr]">
          <Reveal>
            <p className="mb-5 font-mono text-xs uppercase tracking-[0.3em] text-cyan">FAQ</p>
            <h2 className="font-display text-4xl font-extrabold uppercase leading-none text-foreground md:text-6xl">Questions,<br />answered.</h2>
            <p className="mt-6 max-w-sm text-muted-foreground">The things every first-time buyer asks — without the jargon.</p>
          </Reveal>
          <Reveal delay={0.1}>
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((f) => (
                <AccordionItem key={f.id} value={f.id} className="border-border" data-testid={`faq-item-${f.id}`}>
                  <AccordionTrigger className="text-left font-display text-lg font-bold uppercase text-foreground hover:text-cyan hover:no-underline md:text-xl">
                    {f.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-base text-muted-foreground">{f.answer}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
